import React from 'react'
import { FaPlay } from "react-icons/fa6";
const VideoTitle = ({title, overview}) => {
  return (
    <div className='pt-[15%] px-6  md:px-12 absolute w-full aspect-video text-white bg-gradient-to-r from-black'>
      <h1 className='text-2xl md:text-6xl font-bold'>{title}</h1>
      <p className='hidden md:inline-block py-6 text-lg w-1/2'>{overview}</p>

      <div className='flex gap-3'>
         <button type="button" class="text-gray-900 bg-gradient-to-r from-lime-200 via-lime-400 to-lime-500 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-lime-300 dark:focus:ring-lime-800 shadow-lg shadow-lime-500/50 dark:shadow-lg dark:shadow-lime-800/80 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2"> <div className='flex align-center justify-items-center gap-5 '><snap className="text-xl font-bold "> !.. Play</snap></div> </button>
        <button type="button" className="hidden md:inline-block text-white bg-gray-500  hover:bg-gray-900 font-bold rounded-lg text-sm px-10 py-4 me-2 mb-2 dark:bg-gray-800 dark:hover:bg-gray-700  dark:border-gray-700 ">More Info</button>
      </div>
      </div>
  )
}

export default VideoTitle